module.exports = __webpack_public_path__ + "com_index_3bg.jpg?768b192f76b8acad9b870d370648daaa";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_3bg.jpg
// module id = 123
// module chunks = 0